import React, {useEffect, useState} from 'react';
import { Input, Button, Message, SelectPicker, toaster } from "rsuite";
import { AiOutlineUserAdd } from "react-icons/ai";
import UsersTable from "../../components/UsersTable/UsersTable";
import InputMask from "react-input-mask";
import {PHONE_COUNTRIES} from "../../models/Phone.model";
import UsersApi from "../../services/Users.api";

const UsersComponent = () => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneCountry, setPhoneCountry] = useState('RU');
  const [addingUser, setAddingUser] = useState(false);
  useEffect(() => {
    populateUsersData();
  }, []);

  const populateUsersData = async () => {
    setLoading(true);

    try {
      const data = await UsersApi.getUsers();
      setUsers(data);
    } catch (error) {
      console.error('Error fetching users:', error);
      toaster.push(
        <Message type="error" showIcon closable>
          Ошибка загрузки пользователей
        </Message>,
        { placement: 'topEnd' }
      );
    } finally {
      setLoading(false);
    }
  };

  const addUser = async (email, phone) => {
    if (!email && !phone) {
      toaster.push(
        <Message type="warning" showIcon closable>
          Введите email или телефон
        </Message>,
        { placement: 'topEnd' }
      );
      return;
    }

    setAddingUser(true);

    try {
      await UsersApi.createUser(email, phone);
      await populateUsersData();
      setEmail('');
      setPhone('');
      toaster.push(
        <Message type="success" showIcon closable>
          Пользователь успешно создан
        </Message>,
        { placement: 'topEnd' }
      );
    } catch (error) {
      console.error('Error adding user:', error);
      toaster.push(
        <Message type="error" showIcon closable>
          Ошибка создания пользователя: {error instanceof Error ? error.message : 'Неизвестная ошибка'}
        </Message>,
        { placement: 'topEnd' }
      );
    } finally {
      setAddingUser(false);
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      await UsersApi.deleteUser(String(userId));
      await populateUsersData();
      toaster.push(
        <Message type="success" showIcon closable>
          Пользователь успешно удален
        </Message>,
        { placement: 'topEnd' }
      );
    } catch (error) {
      console.error('Error deleting user:', error);
      toaster.push(
        <Message type="error" showIcon closable>
          Ошибка при удалении пользователя
        </Message>,
        { placement: 'topEnd' }
      );
    }
  };

  const handleToggleBlockUser = async (userId, isBlocked) => {
    try {
      await UsersApi.setUserBlocked(String(userId), isBlocked);
      await populateUsersData();
      toaster.push(
        <Message type="success" showIcon closable>
          Пользователь успешно {isBlocked ? 'заблокирован' : 'разблокирован'}
        </Message>,
        { placement: 'topEnd' }
      );
    } catch (error) {
      console.error('Error updating user block status:', error);
      toaster.push(
        <Message type="error" showIcon closable>
          Ошибка при изменении статуса пользователя
        </Message>,
        { placement: 'topEnd' }
      );
    }
  };

  const handleAddUser = async () => {
    const currentPhoneCountry = PHONE_COUNTRIES.find((item) => item.value === phoneCountry) || PHONE_COUNTRIES[0];
    const phoneDigits = phone.replace(/\D/g, '');

    if (phone && phoneDigits.length !== currentPhoneCountry.digitsCount) {
      toaster.push(
        <Message type="warning" showIcon closable>
          Введите телефон полностью
        </Message>,
        { placement: 'topEnd' }
      );
      return;
    }

    const normalizedPhone = phoneDigits || '';
    await addUser(email, normalizedPhone);
  };


  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleAddUser();
    }
  };

  const handlePhoneCountryChange = (value) => {
    setPhoneCountry(value || 'RU');
    setPhone('');
  };

  const currentPhoneCountry = PHONE_COUNTRIES.find((item) => item.value === phoneCountry) || PHONE_COUNTRIES[0];

  return (
    <div className="mt-3">
      <div className="add-user-panel mb-4 p-3" style={{
        backgroundColor: '#f8f9fa',
        borderRadius: '6px',
        border: '1px solid #e9ecef'
      }}>
        <div className="row g-3 align-items-end">
          <div className="col-md-5">
            <label className="form-label">Email</label>
            <Input
              type="email"
              placeholder="Введите email"
              value={email}
              onChange={setEmail}
              onKeyPress={handleKeyPress}
            />
          </div>
          <div className="col-md-5">
            <label className="form-label">Телефон</label>
            <div className="row g-2">
              <div className="col-md-5">
                <SelectPicker
                  cleanable={false}
                  data={PHONE_COUNTRIES}
                  searchable
                  placeholder="Код"
                  value={phoneCountry}
                  onChange={handlePhoneCountryChange}
                  style={{ width: '100%' }}
                />
              </div>
              <div className="col-md-7">
                <InputMask
                  mask={currentPhoneCountry.mask}
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                  maskChar={null}
                  className="rs-input"
                  placeholder={currentPhoneCountry.placeholder}
                  onKeyPress={handleKeyPress}
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <Button
              appearance="primary"
              loading={addingUser}
              onClick={handleAddUser}
              style={{ width: '100%' }}
              startIcon={<AiOutlineUserAdd />}
            >
              Добавить
            </Button>
          </div>
        </div>
      </div>

      <UsersTable
        users={users}
        loading={loading}
        onDeleteUser={handleDeleteUser}
        onToggleBlockUser={handleToggleBlockUser}
      />
    </div>
  );
};

export default UsersComponent;
